import gql from 'graphql-tag'

export const UPDATE_TOPIC = gql`
  mutation academyUpdateTopic($topicId: Int!, $topic: UpdateTopicInput!) {
    academyUpdateTopic(topicId: $topicId, topic: $topic) {
      id
      name
      content {
        questions {
          id
          options {
            id
            right
            title
          }
          type
          desc
          title
        }
      }
      desc
      slug
      topicType
      mediaFromTime
      mediaToTime
      media {
        id
        thumbnail
        source
        url
        fileName
      }
    }
  }
`

export const CREATE_TOPIC = gql`
  mutation academyCreateTopic($topic: TopicInput!) {
    academyCreateTopic(topic: $topic) {
      id
    }
  }
`

export const REMOVE_TOPIC = gql`
  mutation academyRemoveTopics($topicIds: [Int]) {
    academyRemoveTopics(topicIds: $topicIds)
  }
`

export const TOPIC_UPDATE_TAGS = gql`
  mutation academyTopicUpdateTags($topicId: Int!, $tags: [String]) {
    academyTopicUpdateTags(topicId: $topicId, tags: $tags) {
      id
      name
      tags {
        value
      }
      content {
        questions {
          id
          options {
            id
            right
            title
          }
          title
        }
      }
      desc
      slug
      topicType
      mediaFromTime
      mediaToTime
      media {
        id
        thumbnail
        source
        url
        fileName
      }
    }
  }
`

export const ACADEMY_COURSE_UPDATE_TOPIC = gql`
  mutation academyCourseUpdateTopic($courseId: Int!, $topics: [CourseUpdateTopicInput!]!) {
    academyCourseUpdateTopic(courseId: $courseId, topics: $topics) {
      id
      name
      topics {
        id
        name
        order
        topicType
      }
    }
  }
`
